import { ColumnDataType } from '../types'
import { EnrichComponentDatabricks } from './common/enrichcomponent_db'

class EnrichH3Databricks extends EnrichComponentDatabricks {
  constructor() {
    super(
      {
        name: 'native.h3enrich',
        group: 'Data Enrichment',
        title: 'Enrich H3 Grid',
        description: `
      This uses a data source to enrich a target H3 table.
      `,
        starred: true
      },
      'h3',
      [ColumnDataType.String],
      (x) => `H3_BOUNDARYASWKB(${x})`,
      true
    )
  }
}

export { EnrichH3Databricks }
